import { render, staticRenderFns } from "./BaseSwatch.vue?vue&type=template&id=cd9e6d48&"
import script from "./BaseSwatch.vue?vue&type=script&lang=js&"
export * from "./BaseSwatch.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwatch.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/opt/build/repo/storefront/components/atoms/Icon/BaseIcon.vue').default})
